import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({ standalone: false,
  selector: 'irb-dialog-washsale-info',
  templateUrl: './dialog-washsale-info.component.html',
  styleUrls: ['./dialog-washsale-info.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class DialogWashSaleComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<DialogWashSaleComponent>) {}

  ngOnInit() {    
  }

  close() {
    this.dialogRef.close();
  }
}
